import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";
import { Grid } from "@material-ui/core";
import SubcontractorInput from "./SubcontractorInput";
import VehicleSizeInput from "./VehicleSizeInput";
import { useDataProvider } from "react-admin";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import CustomDateRangeInput from "../../../../components/CustomDateRangeInput";
import { AlertTitle } from "@material-ui/lab";

interface AssignedSubcontractorInputProps {
  source: string;
  mode: "create" | "update";
}

const PrefilledSubcontractorInfo = () => {
  return (
    <Alert severity="info" style={{ marginTop: "-10px", marginBottom: "25px" }}>
      <AlertTitle>Info</AlertTitle>
      The data below are pre-filled. Please update below data accordingly as
      necessary for{" "}
      <strong>Subcontractor, Start Date, End Date, Vehicle Size.</strong>
    </Alert>
  );
};

const AssignedSubcontractorInput: React.FC<AssignedSubcontractorInputProps> = ({
  source,
  mode,
}) => {
  const provider = useDataProvider();
  const [subcontractor, setSubcontractor] = useState<ISubcontractor>();

  const assignedSubcontractorField = useField(source);
  const nextEffectiveDate = useField("nextEffectiveDate");

  /**
   * Get the subcontractor details if `subcontractorId` is present.
   * This is used to get the subcontractor contract status and contract date.
   */
  useEffect(() => {
    if (assignedSubcontractorField.input.value.subcontractorId) {
      provider
        .getOne("subcontractors", {
          id: assignedSubcontractorField.input.value.subcontractorId,
        })
        .then(({ data }) => {
          setSubcontractor(data as ISubcontractor);
        });
    } else {
      setSubcontractor(null);
    }
  }, [assignedSubcontractorField.input.value.subcontractorId]);

  return (
    <>
      <Grid item xs={12}>
        {mode === "create" && <PrefilledSubcontractorInfo />}
        <SubcontractorInput
          record={assignedSubcontractorField.input.value}
          parentSource={source}
        />

        {subcontractor?.contractStatus === "inactive" && (
          <Alert
            severity="warning"
            style={{ marginTop: "-10px", marginBottom: "25px" }}
          >
            {moment(subcontractor?.contractUpdatedAt).isAfter(moment(), "day")
              ? `This subcontractor will resign on ${moment
                  .utc(subcontractor?.contractUpdatedAt)
                  .format("DD/MM/YYYY")}.`
              : `This subcontractor resigned on ${moment
                  .utc(subcontractor?.contractUpdatedAt)
                  .format("DD/MM/YYYY")}.`}
          </Alert>
        )}
      </Grid>

      <Grid item xs={12}>
        {mode === "create" && <PrefilledSubcontractorInfo />}
        <CustomDateRangeInput
          fromSource={`${source}.startDate`}
          toSource={`${source}.endDate`}
          fromLabel="Subcontractor Start Date *"
          toLabel="Subcontractor End Date *"
          parentStartDate={moment
            .utc(nextEffectiveDate?.input.value)
            .format("yyyy-MM-DD")}
          fromMaxDate={
            subcontractor?.contractStatus === "inactive"
              ? moment
                  .utc(subcontractor?.contractUpdatedAt)
                  .format("yyyy-MM-DD")
              : null
          }
          toMaxDate={
            subcontractor?.contractStatus === "inactive"
              ? moment
                  .utc(subcontractor?.contractUpdatedAt)
                  .format("yyyy-MM-DD")
              : null
          }
          gridItemWidth={6}
        />
      </Grid>

      <Grid item xs={12}>
        {mode === "create" && <PrefilledSubcontractorInfo />}
        <VehicleSizeInput
          parentSource={source}
          record={assignedSubcontractorField.input.value}
        />
      </Grid>
    </>
  );
};

export default AssignedSubcontractorInput;
